import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentMetrics } from '../../components/SectionContentMetrics'

export const SectionContentInstanceMaraMetrics: React.FunctionComponent =
  () => (
    <Section backgroundColor="black" padding={100}>
      <SectionContentMetrics
        id="mara-metrics"
        heading="Stats that matter"
        metrics={[
          {
            id: 'mara-metric-shift-rating',
            heading: 'Average shift rating',
            value: 4.7,
            format: 'decimal',
          },
          {
            id: 'mara-metric-fill-rate',
            heading: 'Fill rate percentage',
            value: 93,
            format: 'decimal',
          },
          {
            id: 'mara-metric-specialized-roles',
            heading: 'Specialized roles',
            value: 29,
            format: 'decimal',
          },
        ]}
      />
    </Section>
  )
